import { FC, useState } from "react";
import { Icon } from "../Icon";
import { InputWrapper } from "./styles";

export interface ISearchInputBase {
  value?: string;
  placeholder?: string;
  customClassName?: string;
  onChange: (value: string) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SearchInputBase: FC<ISearchInputBase> = ({
  value,
  placeholder,
  customClassName,
  onChange,
  onKeyDown,
}) => {
  const [focus, setFocus] = useState(false);

  const handleChangeSearch = (event: any) => {
    onChange(event.target.value);
  }

  return (
    <InputWrapper $focus={focus} className={customClassName}>
      <Icon
        icon="buscar"
        customSize={12}
        className="iconSearch"
      />
      <input
        type="text"
        value={value}
        className={`input ${customClassName ? customClassName : ''}`}
        placeholder={placeholder}
        onChange={handleChangeSearch}
        onFocus={(e) => setFocus(!!e)}
        onBlur={() => setFocus(false)}
        onKeyDown={onKeyDown}
      />
    </InputWrapper>
  )
}

export default SearchInputBase;
